module.exports = __webpack_public_path__ + "img/no_folllowers_drop@3x.80d891fb.png";